import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comparison-intervention',
  templateUrl: './comparison-intervention.component.html',
  styleUrls: ['./comparison-intervention.component.scss']
})
export class ComparisonInterventionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
